module.exports = __webpack_public_path__ + "static/media/RG_500.eaa2838e.png";